import React from 'react';

import anime from 'animejs';


import Loader from '../views/Loader';
import SourcesBackBlur from '../views/SourcesBackBlur';

import { loadModules, setDefaultOptions } from 'esri-loader';


//<style>.embed-container {position: relative; padding-bottom: 80%; height: 0; max-width: 100%;} .embed-container iframe, .embed-container object, .embed-container iframe{position: absolute; top: 0; left: 0; width: 100%; height: 100%;} small{position: absolute; z-index: 40; bottom: 0; margin-bottom: -15px;}</style><div className="embed-container"><iframe width="500" height="400" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" title="SES Variables for Testing Sites Map 2.0_8.6" src="//yalemaps.maps.arcgis.com/apps/Embed/index.html?webmap=d10a1a63f9fa478ab90052ffc6a4aa2e&extent=-73.7292,40.7087,-71.5484,42.3859&zoom=true&previewImage=false&scale=true&disable_scroll=true&theme=light"></iframe></div>

//<style>.embed-container {position: relative; padding-bottom: 80%; height: 0; max-width: 100%;} .embed-container iframe, .embed-container object, .embed-container iframe{position: absolute; top: 0; left: 0; width: 100%; height: 100%;} small{position: absolute; z-index: 40; bottom: 0; margin-bottom: -15px;}</style><div class="embed-container"><iframe width="500" height="400" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" title="COVID_19 Testing Site Locations by Demographics and Social Vulnerability Index" src="//yalemaps.maps.arcgis.com/apps/Embed/index.html?webmap=f7e21794b1e24ee9b5203bd5d89dd3aa&extent=-74.2153,40.9077,-71.1996,42.119&zoom=true&previewImage=false&scale=true&disable_scroll=true&theme=light"></iframe></div>


import './styles/Main.css';


let webmap = null;
let view = null;

export default class Main extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            sideView: null,
            sourceViewToggled: false
        }
        this.mapRef = React.createRef();
    }

    componentWillMount() {
        this.setState({
            loading: true
        })
    }

    componentDidMount() {
        setDefaultOptions({ css: true, version: '4.16' });

        loadModules(['esri/views/MapView', 'esri/WebMap', 'esri/widgets/Legend', 'esri/widgets/LayerList', 'esri/widgets/Search', 'esri/widgets/Home'])
        .then(([MapView, WebMap, Legend, LayerList, Search, Home]) => {
            webmap = new WebMap({
                portalItem: {
                    // id: "d10a1a63f9fa478ab90052ffc6a4aa2e"
                    id: "f7e21794b1e24ee9b5203bd5d89dd3aa"
                },
            });

            view = new MapView({
                map: webmap,
                container: this.mapRef.current,
                zoom: 9.5,

            });

          

            let searchWidget = new Search({ view: view });
            let homeWidget = new Home({ view: view });
            
            view.ui.add(homeWidget, "top-left");
            view.ui.add(searchWidget, "top-right");


            let wid = document.getElementById('locationTabsWrapper');
      
            view.ui.add(wid, "bottom-right");

            let layerList = new LayerList({
                view: view,
                container: 'map-control-filters'
            });

            view.when(() => {
                wid.style.visibility = "visible";
            }, (error) => {
                console.log(error);
            });

            var legend = new Legend({
                view: view,
                // layerInfos: [{
                // //   layer: layerList,
                //   title: "Legend"
                // }]
            });
            
            view.ui.add(legend, "bottom-left");



        })
        .catch(err => {
            console.log(err);
        })
        .finally(() => {
            this.setState({
                loading: false
            })
        });

        
       
    }

    handleLocClick = (e) => {
        e.preventDefault();
        let dataVal = e.target.dataset.longlat;
        let coord = dataVal.split(" ");
        let temp = coord[0];
        coord[0] = Number(coord[1]);
        coord[1] = Number(temp);
        console.log(coord);

        view.goTo({
            target: coord,
            zoom: 9
        });
    }

    toggleSideView = (shouldOpen) => {
        if(shouldOpen) {
            anime({
                targets: '#side-menu',
                right: [-541, 66],
                direction: 'normal',
                easing: 'easeOutExpo',
                duration: 500,
                loop: false
            });
        }
        else {
            anime({
                targets: '#side-menu',
                right: [66, -541],
                direction: 'normal',
                easing: 'easeOutExpo',
                duration: 500,
                loop: false
            });
        }
    }

    handleAboutClick = (e) => {
        e.preventDefault();
        if(!this.state.sideView) {
            this.setState({
                sideView: 1
            }, () => {
                this.toggleSideView(true)
            })
        }
        if(this.state.sideView && this.state.sideView === 1) {
            this.setState({
                sideView: null
            }, () => {
                this.toggleSideView(false)
            })
        }
        if(this.state.sideView && this.state.sideView !== 1) {
            this.setState({
                sideView: 1
            })
        }
    }
    handlePaperClick = (e) => {
        e.preventDefault();
        if(!this.state.sideView) {
            this.setState({
                sideView: 2
            }, () => {
                this.toggleSideView(true)
            })
        }
        if(this.state.sideView && this.state.sideView === 2) {
            this.setState({
                sideView: null
            }, () => {
                this.toggleSideView(false)
            })
        }
        if(this.state.sideView && this.state.sideView !== 2) {
            this.setState({
                sideView: 2
            })
        }
    }
    handleFeedbackClick = (e) => {
        e.preventDefault();
        if(!this.state.sideView) {
            this.setState({
                sideView: 3
            }, () => {
                this.toggleSideView(true)
            })
        }
        if(this.state.sideView && this.state.sideView === 3) {
            this.setState({
                sideView: null
            }, () => {
                this.toggleSideView(false)
            })
        }
        if(this.state.sideView && this.state.sideView !== 3) {
            this.setState({
                sideView: 3
            })
        }
    }

    toggleSourcesView = (e) => {
        e.preventDefault();
        let dataBox = document.querySelector('#map-data-source');
        this.setState({
            sourceViewToggled: !this.state.sourceViewToggled
        }, () => {
            dataBox.style.height = this.state.sourceViewToggled ? "70%" : "11%";
            dataBox.style.zIndex = this.state.sourceViewToggled ? "400" : "100";
        })
    }

    render() {
        return (
            <div id="main-wrapper">
                <div id="scnd-main-wrapper">
                    {this.state.sideView ? <Loader/> : ''}
                    {this.state.sourceViewToggled ? <SourcesBackBlur />: ''}
                    <div id="proj-title">
                        <h1>The COVID Testing Project</h1>
                    </div>
                    <div className="main-wrapper-float" id="map-control">
                        <div className="map-control-cut" id="map-wrapper">

                            <div className="map-cut-inner" id="map-control-filters">
                                Map Layers
                            </div>

                            <div className="map-cut-inner" id="map" ref={this.mapRef}>
                            {/* <iframe width="100%" height="100%" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" title="SES Variables for Testing Sites Map 2.0_8.6" src="//yalemaps.maps.arcgis.com/apps/Embed/index.html?webmap=d10a1a63f9fa478ab90052ffc6a4aa2e&extent=-72.9924,41.6683,-72.2927,42.0406&zoom=true&previewImage=false&scale=true&search=true&searchextent=true&details=true&legendlayers=true&active_panel=details&disable_scroll=false&theme=dark"></iframe> */}
                                <div id="locationTabsWrapper" className="esri-widget esri-component">
                                    <span data-longlat="34.224 -118.245" className="locTab" id="locTabLA" onClick={this.handleLocClick}>Los Angeles</span>
                                    <span data-longlat="25.575 -80.598" className="locTab" id="locTabMiami" onClick={this.handleLocClick}>Miami</span>
                                    <span data-longlat="41.572 -72.73835" className="locTab" id="locTabConn" onClick={this.handleLocClick}>Connecticut</span>
                                </div>
                            </div>

                        </div>

                        {/* <div className="map-control-cut" id="stats-cut">
                            Statistics
                        </div> */}

                        </div>

                        <div className="main-wrapper-float" id="map-data-source">
                            <span id="svgContainer" title={this.state.sourceViewToggled ? "Collapse" : "Expand"} onClick={this.toggleSourcesView}>
                                {
                                    this.state.sourceViewToggled 

                                    ?

                                    <svg xmlns="http://www.w3.org/2000/svg" height="26" viewBox="0 0 26 26" width="26">
                                        <path d="M0 0h24v24H0z" fill="none" className="svgArrowBorder"/>
                                        <path id="downArrow" d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"/>
                                    </svg>

                                    :

                                    <svg xmlns="http://www.w3.org/2000/svg" height="26" viewBox="0 0 26 26" width="26">
                                        <path d="M0 0h24v24H0z" fill="none" className="svgArrowBorder"/>
                                        <path id="upArrow" d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"/>
                                    </svg>
                                
                                }
                            </span>
                            
                            <div id="source-data">
                                <span id="header-holder"><h2>Data sources</h2></span>

                                <div id="data-holder">
                                    <span className="source-elem">
                                        <p>2018 Census American Community Survey 5-year estimates</p>
                                    </span>

                                    <span className="source-elem">
                                        <p>Centers for Disease Control and Prevention’s <span className="source-elem-bold"><a target="_blank" href="https://svi.cdc.gov">Social Vulnerability Index</a></span></p>
                                        <p>
                                            <span>Social Vulnerability Index (SVI)</span>: The index measures community resilience when challenged by an external threat to human health. 
                                            The CDC’s SVI incorporates 15 U.S. Census social variables at the tract level, including poverty, lack of vehicle access, and crowded housing, and groups them into four related themes: socioeconomic, household composition/disability, minority/language, and housing/transportation. 
                                            Higher SVI values indicate greater relative vulnerability.
                                        </p>
                                    </span>

                                    <span className="source-elem">
                                        <p>The CT Testing Locator by <span className="source-elem-bold"><a target="_blank" href="https://www.211ct.org/search?terms=COVID-19%20Diagnostic%20Tests&page=1&location=Connecticut&taxonomy_code=11048&service_area=connecticut">211ct.org</a></span></p>
                                    </span>

                                    <span className="source-elem">
                                        <p><span className="source-elem-bold"><a target="_blank" href="https://www.giscorps.org/covid-19-testing-site-locator/">GISCorps COVID-19 Testing Sites Locator</a></span></p>
                                    </span>

                                    <span className="source-elem">
                                        <p>Downloadable Databse: <span className="source-elem-bold"><a target="_blank" href="https://github.com/thecovidtestingproject/COVID-19-Testing-Sites-GIS-Data">Github</a></span>, <span className="source-elem-bold"><a target="_blank" href="https://yalemaps.maps.arcgis.com/home/item.html?id=f7e21794b1e24ee9b5203bd5d89dd3aa">Feature Layer</a></span></p>
                                    </span>
                                    
                                </div>

                            </div>  
                        </div>
                        <div id="floating-footer">
                                <span className="float-footer-item" onClick={this.handleAboutClick}>The Team</span>
                                <span className="float-footer-item" onClick={this.handlePaperClick}>Paper</span>
                                <span id="feedback-floating-item" className="float-footer-item" >Feedback</span>
                            </div>

                        <div id="side-menu">
                            {
                                this.state.sideView && this.state.sideView === 1 

                                ?

                                    <div className="side-menu-innerWrapper" id="theTeamWrapper">
                                        <h2 className="side-menu-title">The Team</h2>
                                        <h3 id="shortDesc">The COVID Testing Project is a collaborative effort 
                                            among students and researchers at Yale University.
                                        </h3>

                                        <div className="bioCard">
                                            <img className="bioImage" src="https://i.ibb.co/JdZcGJ4/Screen-Shot-2020-11-15-at-6-58-17-PM.png" />
                                            <h2 className="bioName">Robin Gallagher</h2>
                                            <p className="bioDesc">Robin is majoring in Molecular, Cellular, and Developmental Biology at Yale University.</p>
                                        </div>

                                        <div className="bioCard">
                                            <img className="bioImage" src="https://i.ibb.co/1KCQpsw/Screen-Shot-2020-11-15-at-6-58-49-PM.png" />
                                            <h2 className="bioName">Jessie Gong</h2>
                                            <p className="bioDesc">Jessie is majoring in Molecular, Cellular, and Developmental Biology at Yale University.</p>
                                        </div>

                                        <div className="bioCard">
                                            <img className="bioImage" src="https://i.ibb.co/2q3Svhn/Screen-Shot-2020-11-15-at-6-59-18-PM.png" />
                                            <h2 className="bioName">Connor Grady, BS</h2>
                                            <p className="bioDesc">
                                                Connor is an MPH Candidate majoring in Chronic Disease Epidemiology at the Yale School of Public Health and planning to attend medical school in the Fall of 2021. He graduated from the University of Georgia in 2019 with a BS in microbiology. Contact: <span><a>connor.grady@yale.edu</a></span>
                                            </p>
                                        </div>

                                        <div className="bioCard">
                                            <img className="bioImage" src="https://i.ibb.co/bHFpqxw/Screen-Shot-2020-11-15-at-6-59-40-PM.png" />
                                            <h2 className="bioName">Andy Ma</h2>
                                            <p className="bioDesc">Andy is majoring in Molecular, Cellular, and Developmental Biology at Yale University.</p>
                                        </div>

                                        <div className="bioCard">
                                            <img className="bioImage" src="https://i.ibb.co/qyRRFLk/Screen-Shot-2020-11-15-at-7-00-06-PM.png" />
                                            <h2 className="bioName">Daisy Massey, BA</h2>
                                            <p className="bioDesc">
                                                Daisy is a postgraduate associate at the Yale Center for Outcomes Research and Evaluation in the School of Medicine, where she has been studying health disparities. She graduated from Yale in 2019 with a BA in Philosophy and plans to attend medical school. Contact: <span><a>dorothy.massey@yale.edu</a></span>
                                            </p>
                                        </div>

                                        <div className="bioCard">
                                            <img className="bioImage" src="https://i.ibb.co/RQc9NLs/Screen-Shot-2020-11-15-at-7-00-31-PM.png" />
                                            <h2 className="bioName">Sri Yalamanchi</h2>
                                            <p className="bioDesc">Sri is majoring in Molecular, Cellular, and Developmental Biology at Yale University.</p>
                                        </div>

                                        <div className="bioCard">
                                            <img className="bioImage" src="https://i.ibb.co/868Xsbh/Screen-Shot-2020-11-15-at-7-00-59-PM.png" />
                                            <h2 className="bioName">Joanna Zukin</h2>
                                            <p className="bioDesc">Joanna is double majoring in Cognitive Science and Molecular, Cellular, and Developmental Biology at Yale University.</p>
                                        </div>

                                        <div className="bioCard">
                                            <img className="bioImage" src="https://i.ibb.co/z73dgZF/New-Linked-In-Photo-blacknwhite.jpg" />
                                            <h2 className="bioName">William Darko</h2>
                                            <p className="bioDesc">Undergraduate at Hunter College, studying Computer Science, and Mathematics. Github: <span><a href="https://github.com/williamdarkocode" target="_blank">https://github.com/williamdarkocode</a></span></p>
                                        </div>
                                    </div>

                                :
                                
                                this.state.sideView && this.state.sideView === 2

                                ?

                                <div className="side-menu-innerWrapper" id="paperWrapper">
                                    <h2 className="side-menu-title paper-side-menu-title">An explanation of our methods.</h2>
                                    <div id="paper-textWrapper">
                                        <div className="c18"><p className="c5" id="h.eees67bahzps"><span id="paperTitle" className="c15">Connecticut Testing Site Sources &amp; Feature Layers</span></p><p className="c2" id="h.vw1w3kkx73n7"><span className="c1">We generated a list of &nbsp;COVID-19 diagnostic testing sites located in Connecticut. To compile the list, from July 27, 2020 to July 30, 202 , we cross-checked and verified sites from both </span><span className="c1 c10"><a className="c13" href="https://www.google.com/url?q=https://www.211ct.org/search?terms%3DCOVID-19%2520Diagnostic%2520Tests%26page%3D1%26location%3DConnecticut%26taxonomy_code%3D11048%26service_area%3Dconnecticut&amp;sa=D&amp;ust=1605492513124000&amp;usg=AOvVaw07EybcS-0fZ8RGYJdoMDHO">2-1-1 of Connecticut</a></span><span className="c1">, a website operated by United Way which the Connecticut Department of Public Health directs people to who are searching for a testing location, and a volunteer-updated, in part b COVID-19 Testing Site map provided by the group GISCorp with contributions from the </span><span className="c10 c1"><a className="c13" href="https://www.google.com/url?q=https://covid.yale.edu/innovation/mapping/&amp;sa=D&amp;ust=1605492513124000&amp;usg=AOvVaw29vaNa6SmwuccF66fG5WZy">Yale Mapping COVID Data</a></span><span className="c1">&nbsp;team.</span><span className="c0">1</span><span className="c4 c1">&nbsp;If a site was included on only one list, we verified the site by searching the name online. If a website for the testing site could not be found, we searched for a phone number and called for verification. We excluded 131 testing sites because they were temporary (one day or short-term sites), had no website and phone number information, or provided only serology testing.&nbsp;We did not update the lists after July 30, 2020.</span></p><p className="c5"><span className="c4 c1">We geocoded testing site locations using Geocodio, an online geocoding platform, to determine the Census tract and geographic coordinates of each site. Out of 171 sites, 14 had accuracy scores below 1, indicating an imperfect match with Geocodio&rsquo;s location points, which are derived from over 1,600 sources (including the US Census Bureau). We manually checked the 14 unverified sites using Google Maps which revealed two sites required new coordinates and Census tract assignment. &nbsp;</span></p><p className="c11"><span className="c4 c1">We included layers for Census tract-level demographic information from the United States Census Bureau&rsquo;s American Community Survey (ACS) 5-year estimates from 2014-2018 from ESRI&rsquo;s Living Atlas. &nbsp;Layers include total population, median age, median income, and the percent population by race (White, Black or African American, Hispanic, Asian, and Other which includes American Indians, Hawaiians/Pacific Islander, Alaskan Natives, and those who identify as more than one race). The ACS is an ongoing survey that collects data each month, from January to December of each year. It differs from the 10-year Census in that it is sent to a sample of addresses of about 3.5 million in the Continental US, and in Puerto Rico.&nbsp;</span></p><p className="c5 c12"><span className="c1">We included a layer from ESRI&rsquo;s Living Atlas of the Social Vulnerability Index (SVI) of each Census tract using the 2018 SVI measures from the Geospatial Research, Analysis, and Services Program (GRASP) at the CDC. SVI is a measure of ability to withstand disasters, and was created in order to determine public health and medical preparedness and response capabilities nationwide as a part of the Pandemic and All-Hazards Preparedness Act of 2006.</span><span className="c0">2</span><span className="c1">&nbsp;The CDC SVI is a composite percentile rate made up of data from four areas: socioeconomic status, including income and unemployment data; household composition and disability, including elderly population and disability data; minority status and language; and housing and transportation, including multi-unit structures and access to a vehicle data. The 2018 CDC SVI has been used by others to study COVID-19 disparities,</span><span className="c0">3</span><span className="c1">&nbsp;and similar SVIs have also been used.</span><span className="c0">4</span><span className="c4 c1">&nbsp;All data for the CDC SVI comes from the US Census Bureau&rsquo;s 2014-2018 ACS.</span></p><p className="c5 c6"><span className="c4 c1"></span></p><ol className="c8 lst-kix_e01hv0kirikm-0 start" start="1"><li className="c7"><span className="c4 c1">GISCorps Us. COVID-19 Testing Sites Data Creation Project. ArcGIS, 2020.</span></li><br/><li className="c7"><span className="c1">Flanagan BE, Hallisey EJ, Adams E, et al. Measuring Community Vulnerability to Natural and Anthropogenic Hazards: The Centers for Disease Control and Prevention&#39;s Social Vulnerability Index. </span><span className="c1 c9">J Environ Health</span><span className="c1 c4">&nbsp;2018;80(10):34-36. [published Online First: 2018/06/01]</span></li><br/><li className="c7"><span className="c1">Nayak A, Islam SJ, Mehta A, et al. Impact of Social Vulnerability on COVID-19 Incidence and Outcomes in the United States. </span><span className="c1 c9">medRxiv</span><span className="c4 c1">&nbsp;2020 doi: 10.1101/2020.04.10.20060962 [published Online First: 2020/06/09]</span></li><br/><li className="c7"><span className="c1">Kim SJ, Bostwick W. Social Vulnerability and Racial Inequality in COVID-19 Deaths in Chicago. </span><span className="c1 c9">Health Education &amp; Behavior</span><span className="c4 c1">&nbsp;2020;47(4):509-13. doi: 10.1177/1090198120929677</span></li></ol><p className="c6 c16"><span className="c4 c17"></span></p></div>
                                    </div>
                                </div>

                                :

                                this.state.sideView && this.state.sideView === 3

                                ?

                                "Feedback"

                                :

                                ""
                            }
                            </div>
                </div>
            </div>
        )
    }
}